import React from "react";
import { useTranslation } from "react-i18next";
import { ADVANCE_APPLICATION_PROPETIES } from "infrastructure/enum/object-properties.enum";
import { RadioButton } from "ui/RadioButton";
import { ApplicationTypeComponentProps } from "../types";

export const ApplicationTypeComponent: React.FC<
  ApplicationTypeComponentProps
> = ({
  isExpense,
  expenseTypes,
  expenseType,
  typeRadioClickHandler,
  editMode,
  editPermissions,
}) => {
  const { t, i18n } = useTranslation();

  return (
    <>
      <div className="title">
        {t(
          isExpense
            ? "create_expense.application_type"
            : "modals.create_advance_report_modal.application_type"
        )}
      </div>
      <div className="input-item">
        <div className="box-modal-checkbox-wrap">
          {expenseTypes.map((expType) => (
            <RadioButton
              key={expType.id}
              name="expenseTypeRadio"
              id={expType.id}
              label={expType.name[i18n.language as "ru" | "en"]}
              checked={expType.id === expenseType}
              onClick={typeRadioClickHandler}
              disabled={
                editMode &&
                (isExpense ||
                  !editPermissions.includes(
                    ADVANCE_APPLICATION_PROPETIES.APPLICATION_TYPE
                  ))
              }
            />
          ))}
        </div>
      </div>
    </>
  );
};
